
<input
  *ngIf="allowFiles"
  #fileInputEl
  type="file"
  multiple
  hidden
  (change)="onFilesSelected($event)"
>

<div class="chat-input__shimmer" *ngIf="isRecording" aria-hidden="true">
  <div class="chat-input__shimmer-wave"></div>
</div>

<div *ngIf="attachedFiles.length" class="file-viewer">
  <div *ngFor="let attachedFile of attachedFiles" class="file-viewer__item">
    <div class="file-viewer__meta">
      <div class="file-viewer__name">{{ attachedFile.file.name }}</div>
      <div class="file-viewer__size">{{ getFileSizeLabel(attachedFile.file.size) }}</div>
    </div>

    <button
      ui-kit
      buttonFunction
      class="file-viewer__remove"
      iconName="cross"
      color="neutral"
      size="small"
      type="button"
      title="Удалить файл"
      (click)="removeFile(attachedFile.id)"
    ></button>
  </div>
</div>

<textarea
  *ngIf="isExpanded && !isRecording"
  #textareaExpandedEl
  class="chat-input__textarea chat-input__textarea--expanded"
  rows="1"
  placeholder="Введите сообщение..."
  [formControl]="textControl"
  (keydown.enter)="onEnter($event)"
  (paste)="onPaste($event)"
></textarea>

<div class="one-line">
  <div *ngIf="allowFiles" class="add-file-button">
    <button
      ui-kit
      buttonFunction
      class="chat-input__attach"
      iconName="clip"
      color="neutral"
      size="small"
      type="button"
      title="Прикрепить файл"
      [disabled]="isRecording"
      (click)="openFilePicker()"
    ></button>
  </div>

  <div class="textarea-wrapper" [class.textarea-wrapper--recording]="isRecording">
    <div class="fake-text" #fakeTextEl>{{ textFakeChanges$ | async }}</div>
    <textarea
      *ngIf="!isExpanded || isRecording"
      #textareaEl
      rows="1"
      class="chat-input__textarea"
      placeholder="Введите сообщение..."
      [formControl]="textControl"
      (keydown.enter)="onEnter($event)"
      (paste)="onPaste($event)"
    ></textarea>
    <div
      class="chat-input__recording-timer"
      *ngIf="isRecording"
      aria-live="polite"
    >{{ recordingElapsedLabel }}</div>
  </div>

  <div class="actions">
    <div
      class="chat-input__hold-tooltip"
      [class.chat-input__hold-tooltip--visible]="showHoldTooltip"
      [class.chat-input__hold-tooltip--detached]="showHoldTooltip && !(allowVoice && !showCancelButton)"
      role="tooltip"
    >{{ holdTooltipText }}</div>

    <div class="chat-input__mic-wrap" *ngIf="allowVoice && !showCancelButton">
      <button
        ui-kit
        buttonFunction
        class="chat-input__mic chat-input__mic--inline"
        [class.chat-input__mic--recording]="isRecording"
        iconName="mic"
        [color]="isRecording ? 'accent' : 'neutral'"
        size="small"
        type="button"
        title="Голосовой ввод"
        (pointerdown)="onMicPointerDown($event)"
      ></button>
    </div>

    <button
      ui-kit
      [icon]="showCancelButton ? 'stop' : 'send'"
      class="chat-input__send"
      [class.chat-input__send--stop]="showCancelButton"
      [color]="showCancelButton || textControl.value.trim() || attachedFiles.length ? 'primary-accent' : 'secondary-neutral'"
      size="small"
      type="button"
      [disabled]="isRecording || (showCancelButton ? false : (!textControl.value.trim() && !attachedFiles.length))"
      [title]="showCancelButton ? 'Остановить генерацию' : 'Отправить'"
      (click)="send()"
    ></button>
  </div>
</div>
